import type { SyntheticEvent } from 'react';

export default function extractValue<Name = string, Value = any>(
  event: EventOrValue<Name, Value>,
): { name: Name; value: Value } {
  const target =
    (event as SyntheticEvent).target ||
    (event as SyntheticEvent).currentTarget ||
    event ||
    {};
  const { checked, name, value, type } = target as any;

  let actualValue = value;
  if (type === 'checkbox' && checked !== undefined) {
    actualValue = checked;
  }

  return {
    name,
    value: actualValue,
  };
}

export type EventOrValue<Name = string, Value = any> =
  | {
      name: Name;
      value: Value;
    }
  | SyntheticEvent;
